import { createRoot } from "react-dom/client";

import { initAnalytics } from "@needl-ai/common/analytics";
import {
  isICRAResearchAssist,
  isMSquaredHub,
} from "@needl-ai/common/utils/isEnv";
import {
  REQUEST_ORIGINS,
  setRequestOrigin,
} from "@needl-ai/common/utils/requestOrigin";

import App from "./App.tsx";

import "@/vendor/styles/globals.css";
import "./index.css";
import { loadFrozenBranding } from "@/vendor/loadFrozenBranding";

if (isMSquaredHub()) {
  setRequestOrigin(REQUEST_ORIGINS.ASKNEEDL_AGENT_MSQUARED_HUB);
} else if (isICRAResearchAssist()) {
  setRequestOrigin(REQUEST_ORIGINS.ASKNEEDL_AGENT_ICRA_RESEARCH_ASSIST);
} else {
  setRequestOrigin(REQUEST_ORIGINS.RESEARCH_ASSIST);
}

const BASE_PATH = import.meta.env.VITE_BASE_PATH_RESEARCH_ASSIST || "";

const enableMocking = async (): Promise<void> => {
  if (import.meta.env.DEV) {
    const { worker } = await import("@/mocks/browser");
    await worker.start({
      serviceWorker: {
        url: `${BASE_PATH}/mockServiceWorker.js`,
      },
    });
  }
};

initAnalytics();

Promise.all([loadFrozenBranding(), enableMocking()]).then(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
